import { createContext, useContext, useState, useCallback, useRef, useMemo } from "react";

const ToastCtx = createContext({ toast: () => {} });

const ICON = { info: "bi-info-circle-fill", ok: "bi-check-circle-fill", err: "bi-exclamation-triangle-fill" };

export function ToastProvider({ children }) {
  const [items, setItems] = useState([]);
  const seq = useRef(0);

  const dismiss = useCallback(id => setItems(list => list.filter(t => t.id !== id)), []);

  /** toast(poruka, tip, trajanje, { action: { label, run } }) */
  const toast = useCallback((message, type = "info", ms = 3200, opts = {}) => {
    const id = ++seq.current;
    setItems(list => [...list, { id, message, type, action: opts.action }]);
    if (ms > 0) setTimeout(() => dismiss(id), ms);
    return id;
  }, [dismiss]);

  /** Poruka s gumbom "Poništi" (umjesto dijaloga za potvrdu brisanja). */
  const undoable = useCallback((message, undo, ms = 7000) =>
    toast(message, "info", ms, { action: { label: "Poništi", run: undo } }), [toast]);

  const value = useMemo(() => ({ toast, dismiss, undoable }), [toast, dismiss, undoable]);

  return (
    <ToastCtx.Provider value={value}>
      {children}
      <div className="toast-wrap" role="status" aria-live="polite">
        {items.map(t => (
          <div key={t.id} className={`toast ${t.type}`}>
            <i className={`bi ${ICON[t.type] || ICON.info}`} />
            <span>{t.message}</span>
            {t.action && (
              <button className="toast-act" onClick={() => { t.action.run(); dismiss(t.id); }}>{t.action.label}</button>
            )}
            <button onClick={() => dismiss(t.id)} aria-label="Zatvori"><i className="bi bi-x-lg" /></button>
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export const useToast = () => useContext(ToastCtx);
